import { toaster } from "@/utilities/toaster";
import { assign, Machine } from "xstate";
import { FormModule } from "../../../../../store/modules/paForm.module";
const formsListingMachine = Machine({
    id: "formMachine",
    context: {
        searchData: {
            page: 1,
            pageSize: 10,
            sort: {
                field: "formName",
                type: "none",
            },
            columnFilters: [],
        },
        formId: "",
        ispageChanged: false,
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                GETTING_FORMS: { target: "gettingForms" },
            },
        },
        gettingForms: {
            invoke: {
                id: "gettingForms",
                src: (context, event) => {
                    return FormModule.GetForms(context.searchData);
                },
                onDone: { target: "loadedForms" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedForms: {
            on: {
                GETTING_FORMS: { target: "gettingForms", actions: "assignSearchData" },
                DUPLICATE_FORM: { target: "duplicatingForm" },
                ARCHIVE_FORM: { target: "archivingForm", actions: "ispageChanged" },
                DELETE_FORM: { target: "deleteForm", actions: "ispageChanged" },
            },
        },
        duplicatingForm: {
            invoke: {
                id: "duplicatingForm",
                src: (context, event) => {
                    return FormModule.DuplicateForm(event.formId);
                },
                onDone: { target: "gettingForms", actions: "showSuccessMessage" },
                onError: { target: "loadedForms" },
            },
        },
        archivingForm: {
            invoke: {
                id: "archivingForm",
                src: (context, event) => {
                    return FormModule.ArchiveOrUnArchiveForm({ formId: event.formId, isArchive: event.isArchived });
                },
                onDone: { target: "gettingForms", actions: ["showSuccessMessage", "setPage"] },
                onError: { target: "loadedForms" },
            },
        },
        deleteForm: {
            tags: "showDeleteFormUI",
            on: {
                DELETING_FORM: { target: "deletingForm" },
                CANCEL_FORM: { target: "loadedForms" },
            },
        },
        deletingForm: {
            tags: "showDeleteFormUI",
            invoke: {
                id: "deletingForm",
                src: (context, event) => {
                    return FormModule.DeleteFormById(event.formId);
                },
                onDone: { target: "gettingForms", actions: ["showSuccessMessage", "setPage"] },
                onError: { target: "loadedForms" },
            },
        },
        serviceUnavailable: {},
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignSearchData: assign({
            searchData: (context, event) => event.searchData,
        }),
        setPage: assign({
            searchData: (context, event) => {
                if (context.ispageChanged) {
                    return {
                        ...context.searchData,
                        page: context.searchData.page - 1,
                    };
                }
                return context.searchData;
            },
        }),
        ispageChanged: assign({
            ispageChanged: (context, event) => event.ispageChanged,
        }),
    },
    services: {},
});
export default formsListingMachine;
